import { useAppStore } from '@/lib/store';

export function WelcomeScreen() {
  const setStep = useAppStore((s) => s.setStep);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-6 py-12">
      <div className="w-full max-w-md text-center">
        <h1 className="mb-2 text-4xl font-bold tracking-tight text-gray-900">
          FitAfrica
        </h1>
        <p className="mb-8 text-lg text-gray-600">
          AI-powered body measurements from your phone camera
        </p>

        <div className="mb-10 space-y-3 text-left text-sm text-gray-500">
          <div className="flex items-start gap-3">
            <span className="mt-0.5 text-green-500">&#10003;</span>
            <span>25+ body measurements in under 2 minutes</span>
          </div>
          <div className="flex items-start gap-3">
            <span className="mt-0.5 text-green-500">&#10003;</span>
            <span>19 African garment types with tailor-ready output</span>
          </div>
          <div className="flex items-start gap-3">
            <span className="mt-0.5 text-green-500">&#10003;</span>
            <span>Works with normal clothing - no tight outfits needed</span>
          </div>
          <div className="flex items-start gap-3">
            <span className="mt-0.5 text-green-500">&#10003;</span>
            <span>Photos never leave your device - 100% private</span>
          </div>
        </div>

        <button
          onClick={() => setStep('clothing')}
          className="btn-primary"
        >
          Get Started
        </button>

        <p className="mt-4 text-xs text-gray-400">
          No account required. Free to use.
        </p>
      </div>
    </div>
  );
}
